export class Customer {
  public id?: string;
  public name?: string = '';
  public furigana?: string = '';
  public phoneNumber?: string = '';
  public phoneType: number = 1;
  public mobileNumber?: string = '';
  public postalCode?: string = '';
  public address1?: string = '';
  public address2?: string = '';
  public prefecture?: string = '';
  public emailAddress?: string = '';
  public isSubscribe?: boolean;
  public contractEndDate?: Date;

  constructor(init?: Partial<Customer>) {
    Object.assign(this, init);
  }
}
